import React from "react";
import { handleKeyPress_number } from "../../_App/Helpers/helpers";

export default function InventaireDetail({
  t,
  removeitem,
  list_details,
  setlist_details,
  parametrage_caisse,
}: any) {
  const ChangeQuantite = (value: number, index: number) => {
    setlist_details((prev: any) => {
      const newInputs = [...prev];
      newInputs[index] = { ...newInputs[index], quantite: value };
      return newInputs;
    });
  };
  
  return (
    <div>
      <div className="table-responsive">
        <table className="table table-bordered mb-5">
          <thead>
            <tr>
              <th></th>
              <th>{t("Article")}</th>
              <th>{t("code Article")}</th>
              <th>{t("Prix Vente TTC")}</th>
              <th>{t("Qunatite")}</th>
              {parametrage_caisse?.ecart_inventaire && (
                <>
                  <th>{t("Qunatite calculer")}</th>
                  <th>{t("Ecart")}</th>
                </>
              )}
            </tr>
          </thead>
          {list_details.length !== 0 ? (
            <tbody>
              {list_details?.map((item: any, index: number) => (
                <tr key={index}>
                  <td onClick={() => removeitem(item)}>
                    <i className="far fa-trash-alt color-red"></i>
                  </td>
                  <td>{item.article?.titre.fr}</td>
                  <td>{item.article?.code_article}</td>
                  <td>{item?.prix_vente_ttc?.toFixed(3)}</td>
                  <td>
                    <input
                      type="text"
                      value={list_details[index]?.quantite || 0}
                      className="input-gray-border "
                      onKeyPress={handleKeyPress_number}  data-type='numeric' data-typedata-type
                      onChange={(e) => ChangeQuantite(+e.target.value, index)}
                    />
                  </td>
                  {parametrage_caisse?.ecart_inventaire && (
                    <>
                      <td>{item?.stk_before_inventaire}</td>
                      <td>{item?.stk_before_inventaire-list_details[index]?.quantite}</td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          ) : (
            <tr>{t("aucun article")}</tr>
          )}

          <tbody></tbody>
        </table>
      </div>
    </div>
  );
}
